import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'


export default function STPPowerFailureDataPopup(props) {
    const { PreventiveWaterTextField, setPreventiveWaterTextField, handlePreventiveWaterTextFieldTextField } = props
    return (

        <>
            <div className="row details-row">
                <div className="col-12 col-lg-6">
                    <div className="form-group">
                        <label className="d-block" htmlFor="NameofDepartment"><b>MCC No.</b></label>
                        <input type="text"
                            className="form-control"
                            id="energyMPCNo"
                            name='energyMPCNo'
                            disabled
                            value={PreventiveWaterTextField.energyMPCNo}
                            onChange={(e) => handlePreventiveWaterTextFieldTextField(e)}
                        />

                    </div>
                </div>
                <div className="col-md-6 col-lg-6">
                    <div className="form-group">
                        <label className="d-block" htmlFor="NameofDepartment"><b>Power Off Time</b></label>
                        <input type="text"
                            className="form-control"
                            id="powerOffTime"
                            name='powerOffTime'
                            disabled
                            value={PreventiveWaterTextField.powerOffTime}
                            onChange={(e) => handlePreventiveWaterTextFieldTextField(e)}
                        />

                    </div>
                </div>
                <div className="col-12 col-lg-6">
                    <div className="form-group">
                        <label className="d-block" htmlFor="NameofDepartment"><b>Power On Time</b></label>
                        <input type="text"
                            className="form-control"
                            id="powerOnTime"
                            name='powerOnTime'
                            disabled
                            value={PreventiveWaterTextField.powerOnTime}
                            onChange={(e) => handlePreventiveWaterTextFieldTextField(e)}
                        />
                    </div>
                </div>
                <div className="col-12 col-lg-6">
                    <div className="form-group">
                        <label className="d-block" htmlFor="NameofDepartment"><b>Diesel Consumption</b></label>
                        <input type="text"
                            className="form-control"
                            id="dieselConsumtion"
                            name='dieselConsumtion'
                            value={PreventiveWaterTextField.dieselConsumtion}
                            onChange={(e) => handlePreventiveWaterTextFieldTextField(e)}
                        />

                    </div>
                </div>
            </div>

        </>

    )

}